import React from "react";
import { ToastContainer } from "react-toastify";

import SettingsBillingAndPaymentDetails from "./components/SettingsBillingAndPaymentDetails";

const SettingsBillingAndPaymentDetailsApp = (props) => {
  return (
    <>
      <ToastContainer icon={false} />
      <SettingsBillingAndPaymentDetails {...props} />
    </>
  );
};

export default SettingsBillingAndPaymentDetailsApp;
